import script from "./ContextSubMenuWrapper.vue?vue&type=script&lang=ts"
export * from "./ContextSubMenuWrapper.vue?vue&type=script&lang=ts"

import "./ContextSubMenuWrapper.vue?vue&type=style&index=0&id=25aee9d7&lang=css"

const __exports__ = script;

export default __exports__